import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import moment from "moment";
import { TotalProjectHoursAPIs } from "./TotalProjectHoursAPI's";
import ResHoursTRangeForm from "../ResHoursTRangeForm";
import TotalHoursTable from "./TotalHoursTable";
import Header from "../../../components/Header";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";

const TotalProjectHours = () => {
	let token,
		employeeId,
		empDepartment,
		empDesignation = null;
	const defaultSorted = [
		{
			dataField: "hours",
			order: "desc",
		},
	];
	const getColumns = [
		{
			dataField: "taskCategory",
			text: "Task Category",
			sort: true,
		},
		{
			dataField: "taskTitle",
			text: "Task Title",
			sort: true,
		},
		{
			dataField: "hours",
			text: "Hours",
			sort: true,
		},
	];
	const [empList, setEmpList] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [totalProjectHours, setTotalProjectHours] = useState([]);
	const [totalHours, setTotalHours] = useState();
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [empId, setEmpId] = useState(null);
	const [startDateCalender, setStartDateOpenCalender] = useState(false);
	const [endDateCalender, setEndDateOpenCalender] = useState(false);
	const [flag, setFlag] = useState(false);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [showExportExcelBtnLoading, setShowExportExcelBtnLoading] =
		useState(false);

	const exportFileHeaders = [
		{ key: "taskCategory", label: "Task Category" },
		{ key: "taskTitle", label: "Task Title" },
		{ key: "hours", label: "Hours" },
	];
	const startDateHandleChange = (date) => {
		setStartDate(date);
	};
	const endDateHandleChange = (date) => {
		setEndDate(date);
	};
	const startDateOpenCalendar = () => {
		if (startDateCalender) {
			setStartDateOpenCalender(false);
		} else {
			setStartDateOpenCalender(true);
		}
	};

	const endDateOpenCalendar = () => {
		if (endDateCalender) {
			setEndDateOpenCalender(false);
		} else {
			setEndDateOpenCalender(true);
		}
	};
	useEffect(() => {
		setStartDate(moment(new Date()).subtract(30, "days")._d);
		getAllEmployeesList();
	}, []);

	const getAllEmployeesList = () => {
		if (
			empDepartment === "5" || //Accounts
			empDepartment === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" //Abdullah
		) {
			axios
				.get(`${TotalProjectHoursAPIs.GetAllEmpList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmpList(empList);
				});
		} else {
			axios
				.get(`${TotalProjectHoursAPIs.GetSupervisorsEmployeesList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmpList(empList);
				});
		}
	};
	let employeeList = empList.map((data) => {
		return { value: data.employeeId, label: data.name };
	});
	const exportToExcel = (e) => {
		e.preventDefault();
		setShowExportExcelBtnLoading(true);
		axios({
			url: `${
				TotalProjectHoursAPIs.ExportToExcel
			}?EmpId=${empId}&StartDate=${moment(startDate).format(
				"YYYY-MM-DD"
			)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "EmployeeTotalProjectHours.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowExportExcelBtnLoading(false);
			})
			.catch((err) => {
				setShowExportExcelBtnLoading(false);
				if (err.response.data) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Select Employee",
					});
				}
			});
	};
	const getEmpId = (obj) => {
		setEmpId(obj.value);
	};
	const getTotalProjectHours = (e) => {
		e.preventDefault();
		if (empId) {
			setIsLoading(true);
			axios
				.get(
					`${
						TotalProjectHoursAPIs.GetTotalProjectHours
					}?EmpId=${empId}&StartDate=${moment(startDate).format(
						"YYYY-MM-DD"
					)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}&SortBy=${
						sortBy.dataField
					}_${sortBy.order}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then((res) => {
					setTotalProjectHours(res.data["projectHours"]);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setIsLoading(false);
					setTotalHours(res.data.total);
					setFlag(true);
				});
		} else {
			if (empId === 0) {
				setIsLoading(true);
				axios
					.get(
						`${
							TotalProjectHoursAPIs.GetTotalProjectHours
						}?EmpId=${empId}&StartDate=${moment(startDate).format(
							"YYYY-MM-DD"
						)}&EndDate=${moment(endDate).format(
							"YYYY-MM-DD"
						)}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then((res) => {
						setTotalProjectHours(res.data["projectHours"]);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setIsLoading(false);
						setTotalHours(res.data.total);
						setFlag(true);
					});
			} else
				AlertPopups.ErrorAlert.fire({
					text: "Please Select Employee",
				});
		}
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		if (type === "sort" || type === "pagination") {
			if (empId != null) callAPI(type, { page, sortOrder, sortField });
		}
	};
	const callAPI = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				TotalProjectHoursAPIs.GetTotalProjectHours
			}?EmpId=${empId}&StartDate=${moment(startDate).format(
				"YYYY-MM-DD"
			)}&EndDate=${moment(endDate).format(
				"YYYY-MM-DD"
			)}&SortBy=${sortField}_${sortOrder}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;

			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				TotalProjectHoursAPIs.GetTotalProjectHours
			}?EmpId=${empId}&StartDate=${moment(startDate).format(
				"YYYY-MM-DD"
			)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}&SortBy=${
				sortBy.dataField
			}_${
				sortBy.order
			}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;

			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setTotalProjectHours(res.data["projectHours"]);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setTotalHours(res.data.total);
						setFlag(true);
						setIsLoading(false);
						setPageNum(page);
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					TotalProjectHoursAPIs.GetTotalProjectHours
				}?EmpId=${empId}&StartDate=${moment(startDate).format(
					"YYYY-MM-DD"
				)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&PageNumber=${1}&PageSize=${PageSize}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((res) => {
				setTotalProjectHours(res.data["projectHours"]);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setTotalHours(res.data.total);
				setFlag(true);
				setIsLoading(false);
				setPageNum(1);
				setNumberOfItemsPerPage(PageSize);
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				employeeId = userDetails.id;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<div className="container-fluid pl-3 pr-3">
						<Header
							title="Total Project Hours"
							headerBorder={true}
						/>
						<ResHoursTRangeForm
							allEmployees={employeeList}
							exportToExcel={exportToExcel}
							data={totalProjectHours}
							getEmpId={getEmpId}
							startDateOpenCalendar={startDateOpenCalendar}
							endDateOpenCalendar={endDateOpenCalendar}
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startDateCalender={startDateCalender}
							endDateCalender={endDateCalender}
							startDate={startDate}
							endDate={endDate}
							clicked={getTotalProjectHours}
							exportFileHeaders={exportFileHeaders}
							resourceTotalProjectHours={[]}
							showBtnLoading={showExportExcelBtnLoading}
						/>
						<TotalHoursTable
							totalProjectHours={totalProjectHours}
							totalHours={totalHours}
							flag={flag}
							handleTableChange={handleTableChange}
							isLoading={isLoading}
							pagerData={pagerData}
							columns={getColumns}
							defaultSorted={defaultSorted}
							numberOfItemsPerPage={numberOfItemsPerPage}
							pageNum={pageNum}
							receiveData={(pageSize) => receiveData(pageSize)}
						/>
					</div>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default TotalProjectHours;
